export enum GoalKeyResultType {
  BINARY = 'BINARY',
  NUMERIC = 'NUMERIC'
}